// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var FieldType;
(function (FieldType) {
    FieldType["FIELD_TYPE_UNKNOWN"] = "FIELD_TYPE_UNKNOWN";
    FieldType["FIELD_TYPE_TEXT"] = "FIELD_TYPE_TEXT";
    FieldType["FIELD_TYPE_TEXTAREA"] = "FIELD_TYPE_TEXTAREA";
    FieldType["FIELD_TYPE_RADIO"] = "FIELD_TYPE_RADIO";
    FieldType["FIELD_TYPE_CHECKBOX"] = "FIELD_TYPE_CHECKBOX";
    FieldType["FIELD_TYPE_SELECT"] = "FIELD_TYPE_SELECT";
    FieldType["FIELD_TYPE_DATETIME"] = "FIELD_TYPE_DATETIME";
    FieldType["FIELD_TYPE_EMAIL"] = "FIELD_TYPE_EMAIL";
    FieldType["FIELD_TYPE_PHONE"] = "FIELD_TYPE_PHONE";
    FieldType["FIELD_TYPE_RATING"] = "FIELD_TYPE_RATING";
})(FieldType || (FieldType = {}));
export var FieldType_index;
(function (FieldType_index) {
    FieldType_index[FieldType_index["FIELD_TYPE_UNKNOWN"] = 0] = "FIELD_TYPE_UNKNOWN";
    FieldType_index[FieldType_index["FIELD_TYPE_TEXT"] = 1] = "FIELD_TYPE_TEXT";
    FieldType_index[FieldType_index["FIELD_TYPE_TEXTAREA"] = 2] = "FIELD_TYPE_TEXTAREA";
    FieldType_index[FieldType_index["FIELD_TYPE_RADIO"] = 3] = "FIELD_TYPE_RADIO";
    FieldType_index[FieldType_index["FIELD_TYPE_CHECKBOX"] = 4] = "FIELD_TYPE_CHECKBOX";
    FieldType_index[FieldType_index["FIELD_TYPE_SELECT"] = 5] = "FIELD_TYPE_SELECT";
    FieldType_index[FieldType_index["FIELD_TYPE_DATETIME"] = 6] = "FIELD_TYPE_DATETIME";
    FieldType_index[FieldType_index["FIELD_TYPE_EMAIL"] = 7] = "FIELD_TYPE_EMAIL";
    FieldType_index[FieldType_index["FIELD_TYPE_PHONE"] = 8] = "FIELD_TYPE_PHONE";
    FieldType_index[FieldType_index["FIELD_TYPE_RATING"] = 9] = "FIELD_TYPE_RATING";
})(FieldType_index || (FieldType_index = {}));
export var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["SURVEY_STATUS_UNKNOWN"] = "SURVEY_STATUS_UNKNOWN";
    SurveyStatus["SURVEY_STATUS_LIVE"] = "SURVEY_STATUS_LIVE";
    SurveyStatus["SURVEY_STATUS_STOPPED"] = "SURVEY_STATUS_STOPPED";
    SurveyStatus["SURVEY_STATUS_ENDED"] = "SURVEY_STATUS_ENDED";
})(SurveyStatus || (SurveyStatus = {}));
export var SurveyStatus_index;
(function (SurveyStatus_index) {
    SurveyStatus_index[SurveyStatus_index["SURVEY_STATUS_UNKNOWN"] = 0] = "SURVEY_STATUS_UNKNOWN";
    SurveyStatus_index[SurveyStatus_index["SURVEY_STATUS_LIVE"] = 1] = "SURVEY_STATUS_LIVE";
    SurveyStatus_index[SurveyStatus_index["SURVEY_STATUS_STOPPED"] = 2] = "SURVEY_STATUS_STOPPED";
    SurveyStatus_index[SurveyStatus_index["SURVEY_STATUS_ENDED"] = 3] = "SURVEY_STATUS_ENDED";
})(SurveyStatus_index || (SurveyStatus_index = {}));
export var SurveyType;
(function (SurveyType) {
    SurveyType["SURVEY_TYPE_UNKNOWN"] = "SURVEY_TYPE_UNKNOWN";
    SurveyType["SURVEY_TYPE_WEB"] = "SURVEY_TYPE_WEB";
    SurveyType["SURVEY_TYPE_TEXT"] = "SURVEY_TYPE_TEXT";
})(SurveyType || (SurveyType = {}));
export var SurveyType_index;
(function (SurveyType_index) {
    SurveyType_index[SurveyType_index["SURVEY_TYPE_UNKNOWN"] = 0] = "SURVEY_TYPE_UNKNOWN";
    SurveyType_index[SurveyType_index["SURVEY_TYPE_WEB"] = 1] = "SURVEY_TYPE_WEB";
    SurveyType_index[SurveyType_index["SURVEY_TYPE_TEXT"] = 2] = "SURVEY_TYPE_TEXT";
})(SurveyType_index || (SurveyType_index = {}));
export var SubmissionMode;
(function (SubmissionMode) {
    SubmissionMode["SUBMISSION_MODE_UNKNOWN"] = "SUBMISSION_MODE_UNKNOWN";
    SubmissionMode["SOLICITED_AUTOREMINDER"] = "SOLICITED_AUTOREMINDER";
    SubmissionMode["SOLICITED_APP"] = "SOLICITED_APP";
    SubmissionMode["TEXT_SURVEY"] = "TEXT_SURVEY";
})(SubmissionMode || (SubmissionMode = {}));
export var SubmissionMode_index;
(function (SubmissionMode_index) {
    SubmissionMode_index[SubmissionMode_index["SUBMISSION_MODE_UNKNOWN"] = 0] = "SUBMISSION_MODE_UNKNOWN";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_AUTOREMINDER"] = 1] = "SOLICITED_AUTOREMINDER";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_APP"] = 2] = "SOLICITED_APP";
    SubmissionMode_index[SubmissionMode_index["TEXT_SURVEY"] = 3] = "TEXT_SURVEY";
})(SubmissionMode_index || (SubmissionMode_index = {}));
